import ReactDOM from 'react-dom/client';
import './styles/index.css';
import './styles/eleve-v2.css';
import './api/offline/patchFetch';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { PrefsProvider } from './context/PrefsContext';
import { ThemeProvider } from './context/ThemeContext';
import { ToastProvider } from './components/ui/ToastProvider';
import { ConfirmProvider } from './components/ui/ConfirmProvider';
import { PromptProvider } from './components/ui/PromptProvider';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from './api/queryClient';
import { initSentry } from './observability/sentry';

// Monitoring erreurs (no-op tant que @sentry/react + DSN ne sont pas configures).
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider client={queryClient}>
    <PrefsProvider>
      <AuthProvider>
        <ThemeProvider>
          <ToastProvider>
            <ConfirmProvider>
              <PromptProvider>
                <App />
              </PromptProvider>
            </ConfirmProvider>
          </ToastProvider>
        </ThemeProvider>
      </AuthProvider>
    </PrefsProvider>
    {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
  </QueryClientProvider>
);